/*
 * @Author: 肖玲
 * @Date: 2022-10-27 16:17:28
 * @LastEditTime: 2023-07-06 18:22:51
 * @LastEditors: 肖玲
 * @Description: 
 * @FilePath: \p2ps_vip_web\src\api\quarter.js
 * 文件备注
 */
import axios from '@/utils/axios'

const rootUrl = 'jurisdiction/website/quarter/'

const api = {
  Edit: rootUrl + 'edit',
  DelQuarter: rootUrl + 'delQuarter',
  StopQuarter: rootUrl + 'stopQuarter',
  QuarterTransfer: rootUrl + 'quarterTransfer',
  DeleteLog: rootUrl + 'deleteLog',
  Detail: rootUrl + 'detail',
  AttachedList: rootUrl + 'attachedList'
}

/**
 * 编辑／添加岗位接口
 */
export function editQuarter(parameter) {
  return axios.formRequest.post(api.Edit, parameter)
}

/**
 * 岗位删除接口
 */
export function delQuarter(pamameter) {
  return axios.formRequest.post(api.DelQuarter, pamameter)
}

/**
 * 岗位停用 / 开启接口
 */
export function onOrOffQuarter(parameter) {
  parameter.is_stop = parameter.is_stop == 0 ? 1 : 0 // 不是我弄的 以前就这样的 
  return axios.formRequest.post(api.StopQuarter, parameter)
}
/**
 * 岗位迁移接口
 */
export function quarterTransfer(target_department_id, array_quarter_id) {
  return axios.formRequest.post(api.QuarterTransfer, {
    target_department_id,
    array_quarter_id,
  })
}

/**
 * 删除记录
 */
export function deleteLog(page = 1, type) {
  return axios.formRequest.post(api.DeleteLog, { page, type })
}

/**
 * 岗位详情
 */
export function detail(quarter_id) {
  return axios.formRequest.post(api.Detail, { quarter_id })
}

/**
 * 附属管理员列表接口
 */
export function attachedList(search = '') {
  return axios.formRequest.post(api.AttachedList, { search })
}

/**
 * 检查岗位对于部门是否已存在负责人
 * quarter_id
 * department_id
 */
export function checkQuarterTop(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/quarter/checkQuarterTop',
    parameter
  )
}
